import { ITimesheet } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';
import { DateTime } from 'luxon';

function formatDateToDDMMYYYY(dateString: string | undefined | null): string {
  if (!dateString) return '';
  const date = DateTime.fromISO(dateString);
  if (!date.isValid) return '';
  return date.toFormat('dd-MM-yyyy');
}

type UsersMap = Record<string, { firstname: string; lastname: string }>;

export const timesheetApi = crudEndpointsFactory<ITimesheet>()('timesheets', 'Timesheets').injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    generatePdf: builder.mutation<any, { startDate: string, endDate: string, userIds?: string[], usersMap?: UsersMap }>({
      query: (params) => ({
        url: 'timesheets/generate-pdf',
        method: 'POST',
        body: {
          startDate: params.startDate,
          endDate: params.endDate,
          ...(params.userIds && params.userIds.length > 0 ? { userIds: params.userIds } : {}),
          ...(params.usersMap ? { usersMap: params.usersMap } : {}),
        },
        responseHandler: async (response) => {
          const data = await response.json();
          if (data.pdf) {
            const base64 = data.pdf.split(',')[1];
            const binary = atob(base64);

            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            const blob = new Blob([bytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            const formattedStartDate = formatDateToDDMMYYYY(params.startDate);
            const formattedEndDate = formatDateToDDMMYYYY(params.endDate);
            a.download = `Rapport_pointages_${formattedStartDate}_au_${formattedEndDate}.pdf`;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            }, 0);
          } else {
            throw new Error("Aucun PDF trouvé dans la réponse");
          }
        },
        cache: "no-cache",
      }),
    }),
  })
});
